import { createAsyncThunk } from '@reduxjs/toolkit'
import axios, { AxiosResponse, AxiosError } from 'axios'
import { API_URL_FELL } from 'config'
import { ProjectType } from 'lib/types'


export const getProjectsThunk = createAsyncThunk<
    AxiosResponse<{ user: any, projects: ProjectType[] }>,
    void,
    { rejectValue: string }
>('projects/getProjects', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.get(`${API_URL_FELL()}/project`);
        return response;
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export const postProjectThunk = createAsyncThunk<
    ProjectType,
    { rejectValue: string }
>('projects/postProject', async (_, { rejectWithValue }) => {
    try {
        const response = await axios.post(`${API_URL_FELL()}/project`);
        return response.data;

    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export const updateProjectThunk = createAsyncThunk<
    ProjectType,
    ProjectType,
    { rejectValue: string }
>('projects/updateProject', async (project: ProjectType, { rejectWithValue }) => {
    try {
        const response = await axios.put(`${API_URL_FELL()}/project/${project.id}`,
            project
        );
        return response.data;
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export type ProjectPayload = {
    data?: ProjectType
    error?: string
}

export const deleteProjectThunk = createAsyncThunk<
    ProjectPayload,
    { projectId: string },
    { rejectValue: string }
>('projects/deleteProject', async (args, { rejectWithValue }) => {
    try {
        await axios.delete(`${API_URL_FELL()}/project/${args.projectId}`)
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})

export const duplicateProject = createAsyncThunk<ProjectType, { projectId: number }, { rejectValue: string }>('projects/duplicate', async ({ projectId }, { rejectWithValue }) => {
    try {
        const response = await axios.post(`${API_URL_FELL()}/project/${projectId}/copy`)
        return response.data
    } catch (err) {
        let error: AxiosError<string> = err
        return rejectWithValue(error.response.data)
    }
})
